class EditMembersController {
    constructor($window, TeamTestProjectServiceApi, ProjectTestingServiceApi) {
        this.$onInit = () => {
            this.init();
        };
        this.init = () => {
            this.state = {
                selectedTeam: { Id: 0, Name: '' }
            };
            this.data = {
                assignedProjects: [],
                availableProjects: []
            };
            this.team = this.resolve.team;
            this.state.selectedTeam = this.resolve.team;
            this.renderProjects(this.team.Id);
        };
        this.renderProjects = (teamId) => {
            this.ProjectTestingServiceApi.getAllTeamProjects(teamId).then((response) => {
                this.data.assignedProjects = response.data;
            });
            this.ProjectTestingServiceApi.getAvailableProjects().then((response) => {
                this.data.availableProjects = response.data;
            });
        };
        this.window = $window;
        this.TeamMemberService = TeamTestProjectServiceApi;
        this.ProjectTestingServiceApi = ProjectTestingServiceApi;
    }
}
angular.module('app').component('editMembersModal', {
    bindings: {
        resolve: '<',
        close: '&',
        dismiss: '&'
    },
    templateUrl: 'scripts/app/partials/TeamAdmin/edit-members.tpl.html',
    controllerAs: 'vm',
    controller: EditMembersController
});
